import {
	authInterceptorFactory,
	axios,
	interceptAndNormalizeResponse,
	requestHeaderNormalizerInterceptor,
	piggyBack
} from "@teaming/io-helpers";

const IO_MEETING_NAMESPACE = "meeting";

export default function ioTeamFactory( { config: { baseUri, }, authService, } ) {
	axios.defaults.baseURL = baseUri;
	axios.interceptors.request.use( requestHeaderNormalizerInterceptor );
	axios.interceptors.request.use( authInterceptorFactory( { authService, } ) );
	axios.interceptors.response.use( ...interceptAndNormalizeResponse() );

	async function createCustomTemplate( { name, description, content, scope, teamId, } ) {
		return axios( {
			method: "post",
			url: "/meeting/template",
			data: { name, description, content, scope, teamId, },
		} );
	}

	async function updateCustomTemplate( { meetingTemplateId, name, } ) {
		return axios( {
			method: "put",
			url: `/meeting/template/${ meetingTemplateId }`,
			data: { name, },
		} );
	}

	const _fetchMeetingTemplates = piggyBack( async ( { scope, } ) => {
		return axios( {
			method: "get",
			url: `/meeting/template?scope=${ scope }`,
		} );
	} );

	async function fetchCustomTemplates( { scope = "", } = {} ) {
		return _fetchMeetingTemplates( { scope, } )
			.then( response => {
				let { data, } = response;
				data = data.filter( template => !template.isTeamingTemplate );
				return {
					...response,
					data,
				};
			} );
	}

	async function fetchTeamingTemplates( { scope = "", } = {} ) {
		return _fetchMeetingTemplates( { scope, } )
			.then( response => {
				let { data, } = response;
				data = data.filter( template => !!template.isTeamingTemplate );
				return {
					...response,
					data,
				};
			} );
	}

	async function deleteCustomTemplate( { meetingTemplateId, } ) {
		return axios( {
			method: "delete",
			url: `/meeting/template/${ meetingTemplateId }`,
		} );
	}

	return {
		namespace: IO_MEETING_NAMESPACE,
		createCustomTemplate,
		fetchCustomTemplates,
		fetchTeamingTemplates,
		updateCustomTemplate,
		deleteCustomTemplate,
	};
}
